import { Component, Vue } from "vue-property-decorator";
import { Variant, RelatedProductModel, TranslationModel, CarbonSavingsModel } from "../models/product";
import { EventBus } from "../events";
import http from "../services/Http";
import AddToCartModal from "./AddToCartModal";

@Component({
    components: {
        AddToCartModal,
    }
})
export default class AddToCartContainer extends Vue {
    public $refs!: {
        swiper: any;
        popup: any;
        checkoutbutton: any;
    };
    protected vm: any = {};
    protected isModalVisible: boolean = false;
    protected shoppingListPrevious: boolean = false;
    protected carbonSavingsModel: CarbonSavingsModel = { isCurrentVariantECO: false, ecoVariantName: "", mainVariantName: "", ecoVariantUrl: "",
    globalWarmingPotentialMainProduct: 0, globalWarmingPotentialECOProduct: 0, savingsComparedToNonECOVariant: 0, mainVariantUrl: "", thisIsHowWeCalculatedPageUrl: "",
    imageUrl: "", ecoVariantId: "",
    currentVariantId: "", packagingFactor: 0 };
    protected quantity: number = 0;
    private translations: TranslationModel;
    private readonly apiUrl: string = "/api/common";

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected mounted() {
        EventBus.$on("productAddedToCart", (variantId: string, carbonSavingsModel: CarbonSavingsModel = this.carbonSavingsModel, quantity: number = 0, shoppingList: boolean = false, isProductSelectorPage: boolean = false) => {
            this.carbonSavingsModel = carbonSavingsModel;
            this.quantity = quantity;
            if (this.vm.product && this.vm.product.systemId === variantId && this.vm.shoppingList === shoppingList) {
                this.showModal();
            } else {
                    this.fetchAddToCartInfo(variantId, shoppingList, isProductSelectorPage);
            }
        });

        EventBus.$on("productAddedToCartArticleNumber", (variantId: string, shoppingList: boolean = false) => {
            if (this.vm.product && this.vm.product.articleNumber === variantId && this.vm.shoppingList === shoppingList) {
                this.showModal();
            } else {
                    this.fetchAddToCartInfoArticleNumbers(variantId, shoppingList);
            }
        });

        EventBus.$on("productAddedToCartMultipleVariants", (variantSystemIds: string, shoppingList: boolean = false) => {
            this.fetchAddToCartInfoMultipleVariants(variantSystemIds, shoppingList);
        });

        EventBus.$on("productAddedToCartConfigurator", (configuratorType: string, shoppingList: boolean = false) => {
            this.fetchAddToCartInfoConfigurator(configuratorType, shoppingList);
        });
    }

    protected showModal() {
        this.isModalVisible = true;
        document.body.classList.add("addedtocartscroll--hidden");
    }

    protected closeModal() {
        this.isModalVisible = false;
        document.body.classList.remove("addedtocartscroll--hidden");
    }

    private async fetchAddToCartInfo(variantId: string, shoppingList: boolean, isProductSelectorPage: boolean) {
        http.get<any>(`${this.apiUrl}/addtocartinfo/${variantId}/${shoppingList}/${isProductSelectorPage}`)
                .then(response => {
                    this.vm = response;
                    this.showModal();
                });
     }

    private async fetchAddToCartInfoMultipleVariants(variantIds: string, shoppingList: boolean) {
        http.get<any>(`${this.apiUrl}/addtocartinfomulitplevariants/${variantIds}/${shoppingList}`)
                .then(response => {
                    this.vm = response;
                    EventBus.$emit("hideUBlockCalculator");
                    this.showModal();
                });
     }

     private async fetchAddToCartInfoConfigurator(configuratortype: string, shoppingList: boolean) {
        http.get<any>(`${this.apiUrl}/addtocartinfoconfigurator/${configuratortype}/${shoppingList}`)
                .then(response => {
                    this.vm = response;
                    this.showModal();
                });
     }

     private async fetchAddToCartInfoArticleNumbers(articleNumbers: string, shoppingList: boolean) {
        http.get<any>(`${this.apiUrl}/addtocartinfoarticlenumbers/${articleNumbers}/${shoppingList}`)
                .then(response => {
                    this.vm = response;
                    this.showModal();
                });
     }
}
